import { render, staticRenderFns } from "./ReviewTab.vue?vue&type=template&id=03f2991e&scoped=true&"
import script from "./ReviewTab.vue?vue&type=script&lang=js&"
export * from "./ReviewTab.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTab.vue?vue&type=style&index=0&id=03f2991e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f2991e",
  null
  
)

export default component.exports